import { store } from "../store";
import { createSelector } from "reselect";
import {
  getMarketData,
  getAnnualRevenue,
  getUKRevenue,
} from "../store/entities/revenue";
import { roundTo } from "./generalHelpers";
import { getTotalsByLeader } from "./costTotals";

export const getAllRevenueData = createSelector(
  (state) => state.entities.revenue,
  () => {
    // console.log("getAllRevenueData");
    const state = store.getState();
    const markets = getMarketData(state);
    const revenue = getAnnualRevenue(state);
    const ukRevenue = getUKRevenue(state);
    const leadTotal = getTotalsByLeader(state).object.totals.lead;
    const ukInvest = getTotalsByLeader(state).object.grants.lead;
    const leadMatch = leadTotal - ukInvest;
    const { profitMargin, taxRate } = state.entities.revenue.data;

    // console.log(markets);
    // console.log(revenue);
    // console.log(ukRevenue);
    // console.log(leadTotal);
    // console.log(ukInvest);
    // console.log(leadMatch);
    // console.log(profitMargin, taxRate);

    const summary = {
      revenue,
      profit: {},
      cumulativeProfit: {},
      ukShare: {},
      globalShare: {},
      corpTax: {},
      cumulativeCorpTax: {},
      roiInnovate: {},
      roiLead: {},
    };
    const years = ["y1", "y2", "y3", "y4", "y5"];
    let cumulativeCorpTax = 0;

    years.forEach((year) => {
      // console.log(summary);
      summary.profit[year] = roundTo(
        (summary.revenue[year] * profitMargin) / 100,
        0
      );
      summary.ukShare[year] = roundTo(
        (ukRevenue[year] / markets["UK Market"][year]) * 100,
        0
      );
      summary.globalShare[year] = roundTo(
        // console.log(markets.global);
        (summary.revenue[year] / markets.Global[year]) * 100,
        0
      );
      const tax = roundTo((summary.profit[year] * taxRate) / 100, 0);
      summary.corpTax[year] = tax;
      cumulativeCorpTax = cumulativeCorpTax + tax;
      summary.cumulativeCorpTax[year] = cumulativeCorpTax;

      const ukRoi = roundTo(
        ((cumulativeCorpTax - ukInvest) / ukInvest) * 100,
        0
      );
      summary.roiInnovate[year] = ukRoi;

      const leadRoi = roundTo(
        ((summary.profit[year] - leadMatch) / leadMatch) * 100,
        0
      );
      summary.roiLead[year] = leadRoi;
    });
    summary.cumulativeProfit.y1 = summary.profit.y1
    summary.cumulativeProfit.y2 = summary.cumulativeProfit.y1 + summary.profit.y2
    summary.cumulativeProfit.y3 = summary.cumulativeProfit.y2 + summary.profit.y3
    summary.cumulativeProfit.y4 = summary.cumulativeProfit.y3 + summary.profit.y4
    summary.cumulativeProfit.y5 = summary.cumulativeProfit.y4 + summary.profit.y5
    // console.log(summary.cumulativeProfit);
    return summary;
  }
);
